import { useNavigate } from 'react-router-dom';
import { PipelineAPI } from '../../api/PipelineAPI';
import { useMutation } from '../../../request/hooks/useMutation';
import { useAnalyticsTracker } from '../../../tracking/hooks/useAnalyticsTracker';
import { CreatePipelineTrackers } from '../../tracking/create-pipeline-trackers';
import { EditPipelineTrackers } from '../../tracking/edit-pipeline-trackers';

export function usePipelineFlush(
  pipelineId: number,
  isEditing: boolean,
  onSuccessCallback: () => void
) {
  const navigate = useNavigate();
  const { eventTrack } = useAnalyticsTracker();

  const onSuccess = () => {
    if (isEditing) {
      eventTrack({
        action: EditPipelineTrackers.PIPELINE_TRACKER_EDIT_PIPELINE_REVIEW_SUCCESS,
        properties: {
          id: pipelineId
        }
      });
    } else {
      eventTrack({
        action: CreatePipelineTrackers.PIPELINE_TRACKER_CREATE_PIPELINE_REVIEW_SUCCESS,
        properties: {
          id: pipelineId
        }
      });
    }
    onSuccessCallback!();
    navigate('..', { replace: true, relative: 'path' });
  };

  const onFailure = () => {
    if (isEditing) {
      eventTrack({
        action: EditPipelineTrackers.PIPELINE_TRACKER_EDIT_PIPELINE_REVIEW_FAILURE,
        properties: {
          id: pipelineId
        }
      });
    } else {
      eventTrack({
        action: CreatePipelineTrackers.PIPELINE_TRACKER_CREATE_PIPELINE_REVIEW_FAILURE,
        properties: {
          id: pipelineId
        }
      });
    }
  };

  const { mutate, mutationState, error } = useMutation({
    mutationTarget$: () => PipelineAPI.savePipeline(pipelineId),
    onMutationSuccess: () => {
      onSuccess();
    },
    onMutationError: () => {
      onFailure();
    }
  });

  const submitSaveRequest = () => {
    if (isEditing) {
      eventTrack({
        action: EditPipelineTrackers.PIPELINE_TRACKER_EDIT_PIPELINE_REVIEW_SUBMIT_CLICK,
        properties: {
          id: pipelineId
        }
      });
    } else {
      eventTrack({
        action: CreatePipelineTrackers.PIPELINE_TRACKER_CREATE_PIPELINE_REVIEW_SUBMIT_CLICK,
        properties: {
          id: pipelineId
        }
      });
    }

    mutate();
  };

  return {
    submitSaveRequest,
    mutationState,
    error
  };
}
